import { mergeStyleSets, getTheme } from "@fluentui/react/lib/Styling";

const theme = getTheme();

const styles = mergeStyleSets({
  extensionDetails: {
    height: "100%",
    minHeight: 0,
  },
  extensionDetailsOverview: {
    padding: "0px 10px 10px 10px",
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
  },
  extensionDetailsOverviewItems: {
    height: "100%",
  },
  extensionDetailsOverviewTextKey: {
    fontWeight: 500,
  },
  extensionConfiguration: {
    height: "100%",
    minHeight: 0,
    border: `1px solid ${theme.palette.neutralLight}`,
    borderRadius: "4px",
    background: theme.palette.white,
  },
  extensionConfigurationCommandBar: {
    "& .ms-CommandBar": {
      justifyContent: "flex-start",
      paddingLeft: 10,
    },
  },
  extensionConfigurationHeader: {
    marginTop: 10,
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
  },
  extensionConfigurationHeaderText: {
    padding: "5px 15px",
  },
  extensionConfigurationForm: {
    height: "100%",
    minHeight: 0,
    overflow: "auto",
  },
  extensionDetailsForm: {
    width: "100%",
    minHeight: 0,
    padding: "16px",
  },
  extensionDetailsLastField: {
    marginBottom: 16,
  },
  inlineSpinner: {
    display: "inline-block",
    verticalAlign: "middle",
  },
  noConfigFoundText: {
    paddingTop: 10,
  },
});

export { styles };
